import {
  BOARD_RESOLUTION_INVESTOR_TYPES,
  KYC_VERIFICATION_MODE,
  STATUS,
} from "../constants/constants";

/**
 * True when the investor row should be treated as manual KYC
 * (pending review, manual type, or pending manual docs flag).
 */
export const isManualKycRecord = (record = {}) => {
  const mode = record.kycVerificationMode || record.kycType;
  return (
    Boolean(record.hasPendingManualDocs) ||
    mode === KYC_VERIFICATION_MODE.MANUAL ||
    record.kycType === KYC_VERIFICATION_MODE.MANUAL ||
    record.orgStatusId === STATUS.KYC_REVIEW.ID ||
    record.statusId === STATUS.KYC_REVIEW.ID
  );
};

/**
 * Resolve display tag for the Verification Mode column.
 * @returns {{ label: string, color: string }}
 */
export const getKycVerificationModeTag = (mode, record = {}) => {
  if (isManualKycRecord({ ...record, kycVerificationMode: mode })) {
    return { label: KYC_VERIFICATION_MODE.MANUAL, color: "warning" };
  }
  if (mode === KYC_VERIFICATION_MODE.HYBRID) {
    return { label: KYC_VERIFICATION_MODE.HYBRID, color: "purple" };
  }
  return { label: KYC_VERIFICATION_MODE.DIGITAL, color: "blue" };
};

export const canShowBoardResolutionAction = (record = {}) =>
  BOARD_RESOLUTION_INVESTOR_TYPES.includes(record.investorTypeName) &&
  Boolean(record.boardResolution);
